import { useTranslation } from 'react-i18next'

export default (translation, props) => {
  const { t } = useTranslation()
  return t(translation, props)
}